import React from "react";
import { MdClose } from "react-icons/md";
import { useViewerStore } from "../../../../store/store";

const StreetView: React.FC = () => {
    const sceneViewer = useViewerStore(state => state.sceneViewer);

    const closeStreetView = () => {
        const streetViewContainer = document.getElementById("google-street-view-container");
        const canvasContainer = document.getElementById("canvasContainer");

        if (streetViewContainer) {
            streetViewContainer.style.display = "none";
        }

        if (canvasContainer) {
            canvasContainer.classList.remove("canvas-street-view-split");
        }

        if (sceneViewer) {
            sceneViewer.isViewerInSplitMode = false;
            setTimeout(() => {
                sceneViewer.resizeCanvas();
            }, 500);
        }

        useViewerStore.setState({
            isStreetViewVisible: false,
            isRightSidebarOpen: true,
        });
    };

    return (
        <div className="street-view no-pointer-events" id="google-street-view-container">
            <button onClick={closeStreetView} className="street-view--close">
                <MdClose size={24} />
            </button>
            <iframe loading="lazy" className="street-view-iframe"></iframe>
        </div>
    );
};

export default StreetView;